import React from 'react';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { makeStyles, Typography } from '@material-ui/core';
import { DateIcon } from '../Icon';
import { classNames, initValue } from '../../utils';

const useStyles = makeStyles((theme) => ({
  // root: {
  //   borderRadius: '0.625rem',
  //   border: 'solid 1px #e4e7eb',
  //   background: '#fff',
  //   flexGrow: '1',
  //   '& .MuiInput-root': {
  //     height: '2.5rem',
  //   },
  //   '& .MuiInput-underline:before': {
  //     borderBottom: '0',
  //   },
  //   '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
  //     borderBottom: '0',
  //   },
  //   '& .MuiInputBase-input': {
  //     fontSize: '1rem',
  //     fontWeight: '500',
  //     color: '#7d86a9',
  //     fontFamily: 'PingFangHK',
  //   },
  //   '& .MuiIconButton-root': {
  //     padding: '0.75rem',
  //     marginRight: '0.5rem',
  //   },
  //   '& .MuiIconButton-root': {
  //     padding: '0 0.813rem',
  //     margin: 0,
  //   },
  //   '& .MuiInputAdornment-positionStart': {
  //     marginRight: 0,
  //   },
  // },
  root: {
    '& *': {
      padding: '0',
      margin: '0',
      border: '0',
    },
    width: '8.75rem',
    fontFamily: 'NotoSans-Medium',
    flex: '50%',
    height: '2.5rem',
    lineHeight: '2.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    borderRadius: '0.625rem',
    border: 'solid 1px #e4e7eb',
    backgroundColor: '#fff',
    paddingLeft: '0.813rem',
    color: '#2e4469',
    '& .MuiInputBase-root': {
      fontFamily: 'NotoSans-Medium',
      color: '#2e4469',
    },
    '& :focus': {
      backgroundColor: 'unset',
    },
    '& :before': {
      content: 'none',
    },
    ':before': {
      content: 'none !important',
    },
    '& :after': {
      content: 'none',
    },
  },
  flexRowMargin: {
    display: 'flex',
    '& > :nth-child(1)': {
      marginRight: '1.25rem',
    },
  },
  dateIcon: {
    width: '1.125rem',
    height: '1.25rem',
    color: '#5f9df6',
    marginRight: '0.5rem',
    fontFamily: 'NotoSans-Medium',
  },
}));

export default function RightIconDatePicker(props) {
  const { className, value } = props;
  const classes = useStyles();
  return (
    <KeyboardDatePicker
      {...props}
      className={className ? classNames(classes.root, className) : classes.root}
      variant="inline"
      ampm={false}
      value={initValue(value, new Date())}
      onError={console.log}
      disablePast
      ComponentClass={<Typography>123343</Typography>}
      format="yyyy/MM/D"
      InputAdornmentProps={{ position: 'start' }}
      keyboardIcon={<DateIcon className={classes.dateIcon} />}
    />
  );
}
